import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stringToNumber' })
export class StringToNumberPipe implements PipeTransform {

  transform(input: string): number {
    return (input === null || input === undefined || input === '') ? undefined : +input;
  }
}
